import { ScrollSlider } from '@orbis-systems/orbis-react-toolkit';
import React from 'react';

import { Grid, Typography } from '@mui/material';

import EmptyState from '@components/emptyState';
import Loader from '@components/loader';

import AccountCardSkeleton from '@pages/Applications/components/AccountCardSkeleton';
import ApplicationAccountCardList from '@pages/Applications/containers/ApplicationAccountCardList';
import ApplicationAccountDetails from '@pages/Applications/containers/ApplicationAccountDetails';
import CreateApplication from '@pages/Applications/containers/CreateApplication';
import useCreateApplication from '@pages/Applications/containers/CreateApplication/hooks';
import useApplicationsPage from '@pages/Applications/hooks';

import * as environment from '@utils/environment';

import { MainPageContainer, mainPageClasses } from './styles';

function ApplicationsPage() {
	const { forms, loading, handleCreateApplication } = useCreateApplication();

	const {
		applications,
		isLoadingApplicationsList,
		isLoadingApplicationForm,
		fetchApplicationForm,
		isCreatingNewApplication,
	} = useApplicationsPage(() => {
		if (forms.length === 1) {
			handleCreateApplication(forms[0]);
		}
	});

	if (isCreatingNewApplication || loading)
		return (
			<Grid container alignItems={'center'} justifyContent={'center'} sx={{ height: '100vh' }}>
				<Loader />
			</Grid>
		);

	if (!isLoadingApplicationsList && !applications.length) return <EmptyState />;

	return (
		<MainPageContainer container>
			{environment.env.ALLOW_APPLICATION_CREATION === 'true' && (
				<>
					<Grid container justifyContent={'space-between'} alignItems={'center'} mb={3}>
						<Typography variant={'h5'}>
							<b>Accounts & Applications</b>
						</Typography>

						<CreateApplication />
					</Grid>
					<Grid item xs={12}>
						{isLoadingApplicationsList ? (
							<ScrollSlider fullWidth childWidth={282} childHeight={132} space={16} noStretch>
								{Array.from(Array(4).keys()).map(index => (
									<AccountCardSkeleton key={`account-card-skeleton-${index}`} />
								))}
							</ScrollSlider>
						) : (
							<ApplicationAccountCardList handleSelectCard={fetchApplicationForm} />
						)}
					</Grid>
				</>
			)}

			<Grid container className={mainPageClasses.container}>
				<ApplicationAccountDetails
					showLoader={isLoadingApplicationForm || isLoadingApplicationsList}
					applicationStatusRefresh={fetchApplicationForm}
				/>
			</Grid>
		</MainPageContainer>
	);
}

export default ApplicationsPage;
